import React, { useState } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            EXPERIENCE APP | <span className='text-[#152C24]'>PROFILE</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-2 border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Resources Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 md:mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[180px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            {showVideo ? (
              <div className="w-full h-full">
                <video
                  src="https://res.cloudinary.com/dwfdzdaxk/video/upload/v1751107758/Farmnet_demo_videos_website-Profile_m5gkuq.mp4"
                  controls
                  autoPlay
                  className="w-full h-full object-cover"
                />
               
                <img
                  onClick={() => setShowVideo(false)}
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751046974/close_ring_duotone_ralxeq.png"
                  alt="Close"
                  className="absolute top-2 right-2 md:w-16 md:h-16 w-2 h-2 mt-1"
                /> 
              </div>
            ) : (
              <>
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751110157/Screenshot_2025-06-28_at_4.33.48_PM_qhlysc.png"
                  alt="Mobile"
                  className="object-cover w-full h-full"
                />
                {/* Play Icon */}
                <div
                  onClick={() => setShowVideo(true)}
                  className="absolute inset-0 flex justify-center items-center cursor-pointer"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                    alt="Play Icon"
                    className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            SOLUTION | <span className='text-[#152C24]'>PROFILE</span>
          </h1>

          <div className="space-y-2 sm:space-y-1">
            <h2 className="md:text-[32px] font-bold text-[10px]">Problems</h2>
            <p className="md:text-[32px] sm:text-[8px]">Lack of Access to Timely Information</p>
            <p className="md:text-[32px] sm:text-[8px]">Isolation and Limited Knowledge Exchange</p>
            <p className="md:text-[32px] sm:text-[8px]">Limited Access to Experts</p>
            <p className="md:text-[32px] sm:text-[8px]">Market Access and Pricing Transparency</p>
            <p className="md:text-[32px] sm:text-[8px]">Trust Issues with Buyers or Suppliers</p>
            <p className="md:text-[32px] sm:text-[8px]">Financial Exclusion and Lack of Support Networks</p>
            <p className="md:text-[32px] sm:text-[8px]">Unorganized Farming Efforts</p>
          </div>

          <div className="space-y-2 sm:space-y-1">
            <h2 className="md:text-[32px] font-bold text-[10px]">Solutions</h2>
            <p className="md:text-[32px] text-[8px]">§ Farmers share local alerts (e.g., pest sightings, weather changes), and extension officers or experts can broadcast timely advice to all members.</p>
            <p className="md:text-[32px] text-[8px]">§ Peer-to-peer learning through forums, group chats, or discussion boards where farmers share best practices, innovations, and challenges.</p>
            <p className="md:text-[32px] text-[8px]">§ Verified experts can answer questions, host Q&A sessions, or post educational content directly in the app's community space.</p>
            <p className="md:text-[32px] text-[8px]">§ Farmers share current market prices, buyer contacts, and success stories, helping others negotiate better deals.</p>
            <p className="md:text-[32px] text-[8px]">§ A review/rating system and testimonials from the community help farmers make informed decisions about who to trust.</p>
            <p className="md:text-[32px] text-[8px]">§ Farmers share how they applied for programs, give feedback on services, and support each other through savings groups or cooperatives.</p>
            <p className="md:text-[32px] text-[8px]">§ Encouragement, shared success stories, and emotional support from fellow farmers improve morale and resilience.</p>
          </div>
        </div>
        
        <div className="w-1/2">
          <h1 className="text-[18px] md:text-[32px] font-bold mt-8 mb-4 text-black">
            Download App
          </h1>
          <div className="flex flex-row justify-between space-x-2 items-center sm:space-y-0">
           <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />      </a>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
              alt="Google Play"
              className="h-[30px] md:h-[75px] object-contain"
            />
          </div>
        </div>
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;